import {
  ComponentStyleConfig,
  extendTheme,
  ThemeConfig,
} from '@chakra-ui/react'
import { StepsStyleConfig } from 'chakra-ui-steps'

const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
  cssVarPrefix: 'unvest-otc',
}

// Base Styles
const colors = {
  main: '#070713',
  faded: '#7586AD',
  muted: '#647294',
  dimmed: '#1F2546',
  brand: '#467EE5',
  accent: '#97F4EF',

  highlight: '#00A69B',
  lime: '#BEFDD6',
  assertive: '#FF4E70',
  dark: '#0B081F',
  darkish: '#0B172C',
  background: '#151317',
  mid: '#191C3A',
}

const fonts = {
  body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
  mono: "'IBM Plex Mono', 'monospace', sans-serif",
}

const fontSizes = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  '2xl': '1.5rem',
  '3xl': '1.75rem',
  '4xl': '2rem',
  '5xl': '2.25rem',
  '6xl': '3rem',
  '7xl': '3.75rem',
  '8xl': '4.5rem',
  '9xl': '6rem',
}

// Components
const Table: ComponentStyleConfig = {
  baseStyle: {},
  variants: {
    brand: {
      thead: {
        // borderTop: '2px solid',
        // borderLeft: '2px solid',
        // borderRight: '2px solid',
        tr: {
          height: 14,
          background: 'transparent', //colors.dark,
          borderBottom: '2px solid',
          borderBottomColor: colors.mid,
          color: 'muted',
          fontSize: '16px',
          fontWeight: 700,
        },
      },
      tbody: {
        // borderLeft: '2px solid',
        // borderRight: '2px solid',
        tr: {
          borderBottom: '2px solid',
          borderBottomColor: colors.mid,
          background: colors.darkish,
          color: 'white',
          fontWeight: 600,
          fontSize: '18px',
        },
      },
      tfoot: {
        // borderBottom: '2px solid',
        // borderLeft: '2px solid',
        // borderRight: '2px solid',
        tr: {
          background: colors.dark,
          color: 'white',
        },
      },
    },
  },
}
const CustomSteps = {
  ...StepsStyleConfig,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  baseStyle: (props: any) => {
    return {
      ...StepsStyleConfig.baseStyle(props),
      connector: {
        ...StepsStyleConfig.baseStyle(props).connector,
        borderColor: 'transparent!important',
      },
    }
  },
}

// Theme
const theme = extendTheme({
  colors,
  fonts,
  fontSizes,
  components: {
    Table,
    Steps: CustomSteps,
  },
  config,
  styles: {
    global: {
      body: {
        bg: '#0d0c12',
      },
    },
  },
})

export default theme
